import React from 'react';
import styles from './styles.module.css';
import {Button, Title} from '../../../components';

const data = [
  {
    message:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    name: 'Eva Hicks',
  },
  {
    message:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    name: 'Eva Hicks',
  },
  {
    message:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    name: 'Eva Hicks',
  },
  {
    message:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    name: 'Eva Hicks',
  },
];
const GuestComments = () => {
  const Reviews = () => {
    return (
      <div>
        {data.map((review) => {
          return (
            <div className={styles.review}>
              <div className={styles.message}>
                <p>{review.message}</p>
              </div>
              <div className={styles.flexContainer}>
                <img src={'../assets/images/pop4.png'} className={styles.image} alt={"commentImg"}/>
                <Title text={review.name} large />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <Title text={'What Guests Loved Most'} large />
      <Reviews />
      <div style={{marginTop:"0.5rem",marginBottom:"0.5rem"}}>
	      <Button full>View All Reviews</Button>
      </div>

    </div>
  );
};
export default GuestComments;
